import { FormArray, AbstractControl } from '@angular/forms';

export function checkDuplicateName(control: any | AbstractControl): { [key: string]: boolean } {
	if (!control.value || !control.parent) {
		return null;
	}
	const fa = control.parent.parent as FormArray;
	if ((fa.value as Array<any>).some(x => x.name === control.value)) {
		control.markAsTouched();
		return { customNameMustBeUnique: true };
	}
	return null;
}
